<template>
  <swiper ref="mySwiper" :options="swiperOptions" class="promo-slider">
    <swiper-slide v-for="(slide, i) in slides" :key="i">
      <a class="promo-slider__slide" :href="slide.link">
        <h3 class="promo-slider__title">{{ slide.title }}</h3>
        <div class="promo-slider__img-wrapper">
          <img class="promo-slider__img" :src="slide.image" alt="#" />
        </div>
        <span
          class="promo-slider__label"
          v-html="mess['promo_slider_link']"
        ></span>
      </a>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "PromoSlider",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    slides: {
      type: [Array, null],
      default: () => []
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 700,
        loop: true,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      }
    };
  }
};
</script>

<style lang="scss">
@import "PromoSlider";
</style>
